export const UPDATE_TITLE = 'UPDATE_TITLE';
export const DETALLE_SUCURSAL = 'DETALLE_SUCURSAL';